import type { GameState, Move } from "./model";
import {
  generateLegacyLegalMovesUnchecked,
  generateLegalMovesUnchecked,
  generateVersion2LegalMovesUnchecked,
  generateVersion3LegalMovesUnchecked,
  getFrontier,
  isWinningPassageTarget,
} from "./rules";
import {
  GameStateValidationError,
  validateGameState,
  validateLegacyGameState,
  validateVersion2GameState,
  validateVersion3GameState,
} from "./validation";

export { getFrontier, isWinningPassageTarget };

export function getLegalMoves(state: GameState): readonly Move[] {
  const validation = validateGameState(state);
  if (!validation.ok) throw new GameStateValidationError(validation.issues);
  return generateLegalMovesUnchecked(validation.state);
}

/** Rules-version 1 move generation retained for persisted match compatibility. */
export function getLegacyLegalMoves(state: GameState): readonly Move[] {
  const validation = validateLegacyGameState(state);
  if (!validation.ok) throw new GameStateValidationError(validation.issues);
  return generateLegacyLegalMovesUnchecked(validation.state);
}

/** Rules-version 2 move generation retained for persisted match compatibility. */
export function getVersion2LegalMoves(state: GameState): readonly Move[] {
  const validation = validateVersion2GameState(state);
  if (!validation.ok) throw new GameStateValidationError(validation.issues);
  return generateVersion2LegalMovesUnchecked(validation.state);
}

/** Rules-version 3 move generation retained for persisted match compatibility. */
export function getVersion3LegalMoves(state: GameState): readonly Move[] {
  const validation = validateVersion3GameState(state);
  if (!validation.ok) throw new GameStateValidationError(validation.issues);
  return generateVersion3LegalMovesUnchecked(validation.state);
}

export function getLegalMovesFrom(state: GameState, row: number, column: number): readonly Move[] {
  return Object.freeze(
    getLegalMoves(state).filter((move) => move.from.row === row && move.from.column === column),
  );
}
